import request from '@/utils/request.js'

/**
 * 收藏类型，1=文章 2=课程 3=小程序文章 4=小程序课程
 * @param params
 * @returns {AxiosPromise}
 */
export function collection(params) {
    return request({
        closeLoading: true,
        url: '/operateService/api/app/lines/collection',
        method: 'post',
        data: params
    })
}


export function appointment(params) {
    return request({
        url: '/studyService/api/app/course/appointment/record/appointment',
        method: 'post',
        data: params
    })
}

export function cancelAppointment(params) {
    return request({
        url: '/studyService/api/app/course/appointment/record/cancelAppointment',
        method: 'post',
        data: params
    })
}


export function addCollectionInfo(params) {
    return request({
        url: "/operateService/api/app/user/information/collection/addCollectionInfo",
        method: "post",
        data: params
    });
}
